import { render, staticRenderFns } from "./CommunityPicks.vue?vue&type=template&id=29eea370&"
import script from "./CommunityPicks.vue?vue&type=script&lang=js&"
export * from "./CommunityPicks.vue?vue&type=script&lang=js&"
import style0 from "./CommunityPicks.vue?vue&type=style&index=0&id=29eea370&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports